import 'babel-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { AppContainer } from 'react-hot-loader';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import registerServiceWorker from 'registerServiceWorker';

import { initi18next } from 'util/i18n';
import { addMatchMediaListener } from 'util/event';

// A modern alternative to CSS resets
import 'normalize.css';
// Global css setting
import './global.css';

import configureStore from './store';
import Routes from './routes';

const store = configureStore({});
const history = syncHistoryWithStore(browserHistory, store);

const i18n = initi18next(store);

addMatchMediaListener(store);

ReactDOM.render(
	<AppContainer>
		<I18nextProvider i18n={i18n}>
			<Routes store={store} history={history} />
		</I18nextProvider>
	</AppContainer>,
	document.getElementById('content'),
);

if (module.hot) {
	module.hot.accept('./routes', () => {
		const NewRoutes = require('./routes').default; // eslint-disable-line global-require
		ReactDOM.render(
			<AppContainer>
				<I18nextProvider i18n={i18n}>
					<NewRoutes store={store} history={history} />
				</I18nextProvider>
			</AppContainer>,
			document.getElementById('content'),
		);
	});
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js